<template>
<div>
  <div class="schedule-box container">
    <div class="schedule-left">
      <div class="video-box">
        <div class="video">
          <!-- <iframe v-if="iframeConfig.ready" :width="iframeConfig.width" :height="iframeConfig.height" frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=w3016475i72" allowFullScreen="true"></iframe> -->
          <video
            :src="res.video"
            controls="controls"
            :poster="res.poster"
            v-if="iframeConfig.ready"
            :width="iframeConfig.width"
            :height="iframeConfig.height"
          >
            您的浏览器不支持 video 标签。
          </video>
        </div>
        <div class="msg">
          <div>
            <p>
            {{res.videoabout}}
            </p>
            <!-- <a href="" class="more">了解更多</a> -->
          </div>
        </div>
      </div>
     
    </div>
    <div class="schedule-right">
      <h3>最新动态</h3>
      
      <div class="list" v-for="(item, i) in listData" :key="i">
                <div class="line" v-if="i==0"></div>
        <h4>{{ item.title }}</h4>
        <p>
          <a :href="item.link">{{ item.describe }}</a>
        </p>
        <div class="line"></div>
      </div>
      
      <!-- <div class="more">
        <a>更多资讯<img src="../../assets/img/more.png"/></a>
      </div> -->
    </div>
  </div>
  <!-- <div class="scheduleimg container"><img src="../../assets/img/sc.png" /></div> -->
  </div>
</template>
<script>
export default {
  props:['res'],
  data() {
    return {
      listData: [
        // {
        //   title: "媒体聚焦",
        //   about: "阳光底下无“孤读”",
        //   link: "https://mp.weixin.qq.com/s/IdfAaUEcm6nUEtx2Px3y_Q"
        // },
        //  {
        //   title: "媒体聚焦",
        //   about: "郭帆、单霁翔、龚琳娜、邢立达、蒙曼…解锁15位大咖的童年书单",
        //   link: "https://mp.weixin.qq.com/s/ohWkl1AYZAOuo_JQzMdjbg"
        // },
        // {
        //   title: "我要参与",
        //   about: "我要荐书，生成签名海报",
        //   link: "http://h5.sunlove-iread.com/v3/idea/sz2TrLNr"
        // },
        // {
        //   title: "志愿者",
        //   about: "甘肃、贵州、广西、陕西站志愿者限时招募中！",
        //   link: "https://www.sunlove-iread.com/volunteer"
        // },
        {
          title: "媒体聚焦",
          describe: "“阳光关爱·i读计划”进贵州，共享阅读的暖阳",
          link: "https://movement.gzstv.com/news/detail/165860"
        },
         {
          title: "媒体聚焦",
          describe: "甘肃村小来了一群“新老师”",
          link: "https://mp.weixin.qq.com/s/NhW55hEplCfKvFfkw0fmoA"
        },
        {
          title: "我要参与",
          describe: "听听15位名人为这些孩子推荐什么童书？",
          link: "https://www.ximalaya.com/ertong/30520401"
        },
        {
          title: "志愿者",
          describe: "陕西站志愿者限时招募中！",
          link: "https://www.sunlove-iread.com/volunteer"
        }
      ],
      iframeConfig: {
        width: "",
        height: "",
        ready: false
      }
    };
  },
  created() {
     this.$http.get('/Index/Config/data&key=action').then(res=>{
      this.listData = res.value.footswiper;
    })
  },
  methods: {
    iframeAutosize() {
      this.iframeConfig.ready = false;
      this.iframeConfig.width = $(".video").width();
      this.iframeConfig.height = ($(".video").width() / 1280) * 720;
      this.iframeConfig.ready = true;
    }
  },
  mounted() {
    this.iframeAutosize();
    window.onresize = () => {
      return (() => {
        this.iframeAutosize();
      })();
    };
  }
};
</script>
<style lang="less" scoped>
img {
    max-width: 100%;
  }
  .scheduleimg{
    margin:20px auto;
    padding:0 15px;
    img{
      width: 100%;
    }
  }
.schedule-box {
  
  display: flex;
  position: relative;
  z-index: 1000;
  justify-content: space-between;
  height: auto;
  @rw : 514px;
  margin-bottom: 30px;
  .schedule-left {
    padding-right: 20px;
    width: 1680 - @rw;
    .video-box {
      //border-bottom: 2px dotted #dcdcdc;
      overflow: hidden;
      padding: 30px 0 0;
      padding-bottom: 66px;
      .video {
        // width: 750px;
      }
      .msg {
        // width: 335px;
        padding:20px;

        display: flex;
        align-items: center;
        flex-wrap: wrap;
        box-sizing: border-box;
        a.more {
          border: 1px solid #eb565a;
          font-size: 22px;
          color: #eb565a;
          line-height: 40px;
          height: 40px;
          display: block;
          margin: 0 auto;
          width: 150px;
          text-align: center;
        }
        p {
          font-size: 20px;
          font-weight: 300;
          line-height: 28px;
          color: rgba(0, 0, 0, 1);
          opacity: 1;
        }
      }
    }
    .img {
      margin-top: 30px;
    }
  }
  .schedule-right {
    width: @rw;
    //  height: 100%;
    box-sizing: border-box;
    box-shadow: 1px 1px 1px #ccc;
    border: 1px solid #d8e1e2;
    border-top: 3px solid #eb565a;
    //padding: 0 130px;
    margin-top: -54px;
    background: #fff;
    .list{
      width: 80%;
      margin:0 auto;
    }
    p {
      text-align: center;
      line-height: 28px;
      a {
        color: #515a6d;
      }
    }
    .line {
      // width: 175px;
      border-top: 1px solid #bfbfbf;
      margin: 60px auto 30px;
    }
    h3 {
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      line-height: 37px;
      color: rgba(0, 0, 0, 1);
      opacity: 1;
      margin-top: 30px;
    }
    h4 {
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      line-height: 37px;
      color: rgba(235, 86, 90, 1);
      opacity: 1;
    }
  }
}
.more {
  height: 25px;
  line-height: 25px;
  overflow: hidden;
  display: block;
  margin: 60px auto 40px;
  text-align: center;
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 400;
    color: rgba(0, 113, 255, 1);
    height: 18px;
    img {
      margin-left: 10px;
      height: 100%;
    }
  }
}
@media (max-width: 1640px) {
  .schedule-box {
    // height: 950px;
    .schedule-left {
      padding-top: 0px;
      .video-box {
        padding-bottom: 0px;
      }
      .msg {
        width: 100% !important;
        margin-top: 30px;
        // height: 200px;
        display: block !important;
        white-space: pre-line;
        a.more {
          margin-top: 30px !important;
        }
      }
      .img {
        margin-top: 40px;
      }
    }
    .schedule-right {
     // padding: 0 65px;
      // height: 1010px;
      .line {
        // width: 175px;
        margin: 30px auto 15px;
      }
    }
  }
  .more {
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    display: block;
    margin: 30px auto 20px;
    text-align: center;
  }
}
@media (max-width: 1200px) {
  .schedule-box {
    // height: 780px;
    .schedule-left {
      padding-top: 30px;
      width: 550px;
      .video-box {
        padding-bottom: 0px;
      }
      .msg {
        width: 100% !important;
        margin-top: 30px;
        height: auto;
        display: block !important;
        a.more {
          margin-top: 30px !important;
        }
      }
      .img {
        margin-top: 40px;
      }
    }
    .schedule-right {
      //padding: 0 65px;
      // height: 820px;
      width: 310px;
      .line {
        // width: 175px;
        margin: 15px auto 15px;
      }
    }
  }
}
@media (max-width: 992px) {
  .schedule-box {
    height: auto;
    flex-wrap: wrap;
    .schedule-left {
      order: 0;
      padding-top: 30px;
      width: 100%;
      .video-box {
        padding-bottom: 0px;
      }
      .msg {
        width: 100% !important;
        margin-top: 30px;
        height: auto;
        padding-bottom: 40px;
        display: block !important;
        a.more {
          margin-top: 30px !important;
        }
      }
      .img {
        margin-top: 40px;
      }
    }
    .schedule-right {
      margin-top: 20px;
      //padding: 0 65px;
      height: auto;
      width: 100%;
      .line {
        width: 100%;
        margin: 30px auto 30px;
      }
    }
  }
}

@media (max-width: 765px) {
  .schedule-box {
    margin-bottom: 15px;
    .schedule-left {
      padding-right: 0 !important;
      padding-top: 15px;
      .img {
        margin-top: 10px;
      }
      .video-box {
        padding: 0;
        .msg {
          padding: 0 30px 10px !important;
          margin: 10px 0 0;
          a.more {
            font-size: 14px !important;
            line-height: 28px !important;
            height: 28px !important;
          }
          p {
            font-size: 14px !important;
            line-height: 20px !important;
          }
        }
      }
    }
    .schedule-right {
      h3 {
        margin: 20px 0 10px;
      }
      .line {
        width: 100%;
        margin: 10px auto 10px;
      }
    }
  }
  .more {
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    display: block;
    margin: 20px auto 10px;
    text-align: center;
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 113, 255, 1);
      height: 18px;
      img {
        margin-left: 10px;
        height: 50%;
      }
    }
  }
}
</style>